export default function Footer() {
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-background-950" id="footer">
      <div className="px-4 md:px-6 py-14 md:py-16 max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <span className="text-xl font-heading text-background-50">51动漫</span>
            <p className="mt-3 text-sm text-background-400 leading-relaxed">
              51动漫官网致力于为动漫爱好者提供优质的在线观看与下载服务，覆盖日漫、国漫、韩漫等丰富资源，支持动漫全集下拉式免费追更。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              {[
                { label: '平台优势', href: '#features' },
                { label: '追番指南', href: '#cards' },
                { label: '人气排行', href: '#ranking' },
                { label: '专题合集', href: '#index' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => scrollToSection(e, item.href.replace('#', ''))}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4">动漫分类</h3>
            <ul className="space-y-2.5">
              {['日漫专区', '国漫精选', '韩漫频道', '动漫电影'].map((cat) => (
                <li key={cat}>
                  <a
                    href="#topics"
                    onClick={(e) => scrollToSection(e, 'topics')}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer"
                  >
                    {cat}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4">合作伙伴</h3>
            <p className="text-sm text-background-500 leading-relaxed">
              更多合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 51动漫官网 版权所有
          </p>
          <p className="text-xs text-background-600">
            51动漫官网 | 51动漫在线观看 | 51动漫下载 — 动漫全集免费下拉式追更
          </p>
        </div>
      </div>
    </footer>
  );
}